import { SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED, SET_LAYOUT_STYLE_PROPERTY, SET_PROPERTY, SET_REMOTE_PARTICIPANTS, SET_VIDEO_LAYOUT_MODE, SET_VISIBLE_REMOTE_COUNTS } from "./actionType";

export function setVideoLayoutMode(mode, isRemote) {
    return {
        type: SET_VIDEO_LAYOUT_MODE,
        mode,
        isRemote
    }
}

export function setRemoteParticipants(participants) {
    return {
        type: SET_REMOTE_PARTICIPANTS,
        participants
    };
}

export function setVisibleRemoteCounts(count) {
    return {
        type: SET_VISIBLE_REMOTE_COUNTS,
        count
    }
}

export function setLayoutStyleProperty(width, height) {
    return {
        type: SET_LAYOUT_STYLE_PROPERTY,
        width, height
    }
}

export function setRemoteParticipantsWithScreenShare(participantIds) {
    return {
        type: SCREEN_SHARE_REMOTE_PARTICIPANTS_UPDATED,
        participantIds
    };
}

export function setVideoLayoutProperty(data) {
    return {
        type: SET_PROPERTY,
        data
    }
}